import { render, staticRenderFns } from "./msgtypeImage.vue?vue&type=template&id=9cd6f5c4&scoped=true&"
import script from "./msgtypeImage.vue?vue&type=script&lang=js&"
export * from "./msgtypeImage.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeImage.vue?vue&type=style&index=0&id=9cd6f5c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd6f5c4",
  null
  
)

export default component.exports